import isLightOS from './isLightOS'
import { IBridgeOptions, IBridgeResponse } from './interface'

/**
 * 兼容 lightOS 离线包及 tzyj 在线<br>
 * 分为两种情况<br>
 * 在线及离线<br>
 * 在线的情况下，H5应用是运行在 tzyj 的webview里，目前 navigator.userAgent 并没有 lightos，所以只能用 tzyj 自身注入的对象 window.winner<br>
 * 离线包情况下，H5应用是运行在 light 的容器里。因此就可以利用 light 本身提供的SDK，即使 tzyj 自身封装扩展的方法，如获取自选股等，是基于 light 的容器，也需要改造
 * @param method {string}
 * @param params {object}
 * @param success     {function}
 * @param fail     {function}
 * @param complete     {function}
 *
 */
function nativeJSBridgeSync({ method = '', params = {}, success, fail, complete }: IBridgeOptions) {
  if (isLightOS()) {
    // tzyj 在 light 的 基类上自行扩展封装的方法
    // 或 native.readData
    if (method === 'winner.hsJsFunction' || method.indexOf('native.') !== -1) {
      window.LightJSBridge &&
        window.LightJSBridge.call(method, params, (result: IBridgeResponse) => {
          let ret = null
          if (result && result.info && result.info.error_message === 'success') {
            ret = formatResponseData(method, result.data, params.funName)

            typeof success === 'function' && success(ret)
            typeof complete === 'function' && complete(result)
            return
          }

          typeof fail === 'function' && fail(result)
          typeof complete === 'function' && complete(result)
        })
    } else {
      // LightSDK
      window.LightSDK &&
        window.LightSDK.native[method](params, (result: IBridgeResponse) => {
          let ret = null
          if (result && result.info && result.info.error_message === 'success') {
            ret = formatResponseData(method, result.data)

            typeof success === 'function' && success(ret)
            typeof complete === 'function' && complete(result)
            return
          }

          typeof fail === 'function' && fail(result)
          typeof complete === 'function' && complete(result)
        })
    }
  } else {
    // 非 Light 容器，
    // 安卓和IOS的在线版本
    if (typeof window.winner === 'object') {
      window.winner.hsJsFunction(JSON.stringify(params))
    } else if (typeof window.hsJsFunction === 'function') {
      window.hsJsFunction(JSON.stringify(params))
    } else {
      console.warn('请先注入桥接对象！')
    }
  }
}

/**
 * 兼容 lightOS 离线包及 tzyj 在线<br>
 * 分为两种情况<br>
 * 在线及离线<br>
 * 在线的情况下，H5应用是运行在 tzyj 的webview里，目前 navigator.userAgent 并没有 lightos，所以只能用 tzyj 自身注入的对象 window.winner<br>
 * 离线包情况下，H5应用是运行在 light 的容器里。因此就可以利用 light 本身提供的SDK，即使 tzyj 自身封装扩展的方法，如获取自选股等，是基于 light 的容器，也需要改造
 * @param method {string}
 * @param params {object}
 *
 */
function nativeJSBridge<T>({ method = '', params = {} }: IBridgeOptions<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    if (isLightOS()) {
      // tzyj 在 light 的 基类上自行扩展封装的方法
      // 或 native.readData
      if (method === 'winner.hsJsFunction' || method.indexOf('native.') !== -1) {
        window.LightJSBridge &&
          window.LightJSBridge.call(method, params, (result: IBridgeResponse) => {
            let ret = null
            if (result && result.info && result.info.error_message === 'success') {
              ret = formatResponseData(method, result.data, params.funName)

              resolve(ret)
            }
            reject(result)
          })
      } else {
        // LightSDK
        window.LightSDK &&
          window.LightSDK.native[method](params, (result: IBridgeResponse) => {
            let ret = null
            if (result && result.info && result.info.error_message === 'success') {
              ret = formatResponseData(method, result.data)

              resolve(ret)
            }

            reject(result)
          })
      }
    } else {
      // 非 Light 容器，
      // 安卓和IOS的在线版本
      if (typeof window.winner === 'object') {
        window.winner.hsJsFunction(JSON.stringify(params))
      } else if (typeof window.hsJsFunction === 'function') {
        window.hsJsFunction(JSON.stringify(params))
      } else {
        console.warn('请先注入桥接对象！')
      }
    }
  })
}

// 处理下特殊接口的出参
function formatResponseData(method: string, data: any, funName?: string) {
  let formattedData = data
  const result = data.result || data

  // 针对 Array<object>，读取的数据类型为 string,
  // 统一处理为保存的数据类型
  if (method === 'native.readData') {
    if (typeof result === 'string') {
      try {
        formattedData = JSON.parse(result)
      } catch (err) {
        console.error(`${method} 接口处理数据异常`, err)
      }
    }
  }

  // 自选股返回数据为 Array<string>
  // 统一处理为 Array<object>
  if (funName === 'getMyStock' && Array.isArray(result) && result.length) {
    formattedData = result.map(item => {
      let newItem = item
      if (typeof item === 'string') {
        try {
          newItem = JSON.parse(item)
        } catch (err) {
          console.error(`${funName} 接口处理数据异常`, err)
        }
      }

      return newItem
    })
  }

  return formattedData
}

export { nativeJSBridge, nativeJSBridgeSync }
